import React, { useState, useEffect } from 'react';
import { Row, Col, Button, Dropdown, ButtonGroup, Form, Table, Pagination } from 'react-bootstrap';
import { FaCalendarTimes } from 'react-icons/fa';
import { BiCalendarEdit } from 'react-icons/bi';
import axios from '../../../Authservices/axiosInstance';
import './available-leave.css';

export default function AvailableLeaves() {
  const rowsPerPage = 10;
  const [currentPage, setCurrentPage] = useState(1);
  const [data, setData] = useState([]);
  const [loading, setLoading] = useState(true);
  const [searchQuery, setSearchQuery] = useState("");

  // Fetch data from the API
  const fetchData = (query = "", page = 1) => {
    setLoading(true);
    axios
      .get(`https://backend.ems.uk.hiradentallab.com/api/leaves/users/available-leaves`, {
        params: { search: query },
      })
      .then((response) => {
        setData(response.data);
        setLoading(false);
      })
      .catch((error) => {
        console.error("There was an error fetching the data:", error);
        setLoading(false);
      });
  };

  useEffect(() => {
    fetchData(searchQuery, currentPage);
  }, [searchQuery, currentPage]);

  // Handle search input change
  const handleSearchChange = (e) => {
    setSearchQuery(e.target.value);
    setCurrentPage(1); // Reset to the first page on new search
  };

  // Handle page change
  const handlePageChange = (pageNumber) => {
    if (pageNumber >= 1 && pageNumber <= Math.ceil(data.length / rowsPerPage)) {
      setCurrentPage(pageNumber);
    }
  };

  // Prevent form submission default reload
  const handleSearchSubmit = (e) => {
    e.preventDefault();
    fetchData(searchQuery);
  };

  // Calculate page range
  const pageRange = () => {
    const pages = [];
    const totalPages = Math.ceil(data.length / rowsPerPage);
    let startPage = Math.max(currentPage - 1, 1);
    let endPage = Math.min(startPage + 2, totalPages);

    if (endPage - startPage < 2) {
      startPage = Math.max(endPage - 2, 1);
    }

    for (let i = startPage; i <= endPage; i++) {
      pages.push(i);
    }
    return pages;
  };

  return (
    <div className='container-fluid'>
      <h1 className='available-leaves-title'>
        <FaCalendarTimes /> Leave Information
      </h1>
      <hr />
      <h1 className='available-leaves-subtitle'>
        <BiCalendarEdit /> Available Leaves
      </h1>
      <hr />

      <div className='available-leaves-content'>
        <div className='available-leaves-actions'>
          <Row>
            <Col xs={12} md={6} className="d-flex align-items-center mb-2">
              <Dropdown as={ButtonGroup}>
                <Button variant="primary">Show Entries</Button>
                <Dropdown.Toggle split variant="primary" id="dropdown-split-basic" />
                <Dropdown.Menu>
                  <Dropdown.Item href="#/action-1">10</Dropdown.Item>
                  <Dropdown.Item href="#/action-2">25</Dropdown.Item>
                  <Dropdown.Item href="#/action-3">50</Dropdown.Item>
                  <Dropdown.Item href="#/action-4">100</Dropdown.Item>
                </Dropdown.Menu>
              </Dropdown>
            </Col>
            <Col xs={12} md={6} className="d-flex justify-content-end mb-2">
              <div className='search-container'>
                <Form className="d-flex" onSubmit={handleSearchSubmit}>
                  <Form.Control
                    type="search"
                    placeholder="Search"
                    aria-label="Search"
                    className="available-leaves-search"
                    value={searchQuery}
                    onChange={handleSearchChange}
                  />
                </Form>
              </div>
            </Col>
          </Row>
        </div>

        <div className="table-responsive">
          {loading ? (
            <p>Loading...</p>
          ) : (
            <Table striped hover className='table-style'>
              <thead className="available-leaves-table-header">
                <tr className="table-header">
                  <th>SR</th>
                  <th>UserName</th>
                  <th>Name</th>
                  <th>Available Leaves</th>
                  <th>Yearly Leaves</th>
                </tr>
              </thead>
              <tbody>
                {data.slice((currentPage - 1) * rowsPerPage, currentPage * rowsPerPage).map((item, index) => (
                  <tr key={index}>
                    <td>{(currentPage - 1) * rowsPerPage + index + 1}</td>
                    <td>{item.username}</td>
                    <td>{item.name}</td>
                    <td>{item.availableLeaves}</td>
                    <td>{item.usedHolidays}</td>
                  </tr>
                ))}
              </tbody>
              <tfoot className='table-footer'>
                <tr className='pending-leave-table-footer'>
                  <td>Total</td>
                  <td>-</td>
                  <td>{data.length}</td>
                  <td></td>
                  <td></td>
                </tr>
              </tfoot>
            </Table>
          )}
        </div>

        {/* Pagination */}
        <div className="pagination-row">
            <div className="entries-info">
              Showing {(currentPage - 1) * rowsPerPage + 1} to{" "}
              {Math.min(currentPage * rowsPerPage, data.length)} of{" "}
              {data.length} entries
            </div>
            <nav>
              <ul className="pagination no-gap">
                <li
                  className={`page-item ${currentPage === 1 ? "disabled" : ""}`}
                >
                  <a
                    href="/#"
                    className="page-link"
                    onClick={(e) => {
                      e.preventDefault();
                      handlePageChange(currentPage - 1);
                    }}
                  >
                    Previous
                  </a>
                </li>
                {pageRange().map((pageNumber) => (
                  <li
                    key={pageNumber}
                    className={`page-item ${
                      currentPage === pageNumber ? "active" : ""
                    }`}
                  >
                    <a
                      href="/#"
                      className="page-link"
                      onClick={(e) => {
                        e.preventDefault();
                        handlePageChange(pageNumber);
                      }}
                    >
                      {pageNumber}
                    </a>
                  </li>
                ))}
                <li
                  className={`page-item ${
                    currentPage === Math.ceil(data.length / rowsPerPage)
                      ? "disabled"
                      : ""
                  }`}
                >
                  <a
                    href="/#"
                    className="page-link"
                    onClick={(e) => {
                      e.preventDefault();
                      handlePageChange(currentPage + 1);
                    }}
                  >
                    Next
                  </a>
                </li>
              </ul>
            </nav>
          </div>
        </div>
      </div>
  );
}
